export default __webpack_public_path__ + "static/media/home.c9885f31.jpg";